import { Card, CardContent, Grid } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey } from "assets/jss/common-styles";
import { RequestWrapIndicator } from "components/CallServer/RequestWrapIndicator";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import * as React from "react";
import ActionsCourse from "views/Timeline/Components/CardComp/ActionsCourse";
import BodyDefault from "views/Timeline/Components/CardComp/BodyDefault";
import FooterLine from "views/Timeline/Components/CardComp/FooterLine";
import HeaderLine from "views/Timeline/Components/CardComp/HeaderLine";
import IconsLine from "views/Timeline/Components/CardComp/IconsLine";
import TitleLine from "views/Timeline/Components/CardComp/TitleLine";
import { CardCommonActions } from "views/Timeline/Components/CardLib/CardCommonActions";
import { CourseCardSetup } from "views/Timeline/Components/CardLib/CardSetup";
import { ICardProps } from "views/Timeline/Components/CardLib/ICardProps";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    mouseOver: boolean;
    showBody: boolean;
    dialog: any;
}

type Props = ICardProps & WithSnackbar & StyledComponentProps<FeedClassKey>;

/////////////////////////////////////////////////////////////////////////////////////

class CourseCard extends React.PureComponent<Props, IState> {

    private commonActions: CardCommonActions;

    constructor(props: Props) {
        super(props);
        this.state = {
            dialog: null,
            mouseOver: false,
            showBody: null
        }

        this.commonActions = new CardCommonActions(props.onUpdateCard, props.snackbar.showMessage);
    }

    ///
    private handleTextExpanded = (textExpanded: boolean) => {
        this.commonActions.expandText(this.props.item, textExpanded);
    }

    ///
    public render() {
        const {
            feedType,
            classes,
            item,
            onUpdateCard
        } = this.props;

        const { mouseOver } = this.state;

        const env = new CourseCardSetup(this.props, this.state.showBody, null, null, null, null);

        return (
            <>
                <Card
                    id={item.publicationId}
                    className={classes.card}
                    onMouseEnter={() => this.setState({ mouseOver: true })}
                    onMouseLeave={() => this.setState({ mouseOver: false })
                    }
                >
                    <RequestWrapIndicator enabled={item.isUpdating} type="update">

                        <CardContent className={classes.cardContent}>

                            <Grid container>
                                <Grid item xs>
                                    { /* Area 1 */}
                                    <HeaderLine
                                        classes={classes}
                                        data={item}
                                        feedType={this.props.feedType}
                                        fullView={env.fullView}
                                        inApprovalMode={env.inApprovalMode}
                                        mouseOver={mouseOver}
                                        textExpanded={env.textExpanded}
                                        topMessageMode={env.topMessageMode}
                                        onUpdateCard={onUpdateCard}
                                    />

                                    { /* Area 3 */}
                                    <TitleLine
                                        classes={classes}
                                        data={item}
                                        feedType={this.props.feedType}
                                        fullView={env.fullView}
                                        onTitleClick={env.titleHandle}
                                    />
                                </Grid>
                                <Grid item>
                                    { /* Area 2 */}
                                    <IconsLine
                                        data={item}
                                        feedType={this.props.feedType}
                                        mouseOver={mouseOver}
                                        textExpanded={env.textExpanded}
                                        classes={classes}
                                        onEditPublication={env.editHandle}
                                        onRemovePublication={env.deleteHandle}
                                        onTextExpandedChange={this.handleTextExpanded}
                                        onCustomAction={this.props.onCustomAction}
                                    />
                                </Grid>
                            </Grid>

                            { /* Area 4, 5 e 6 */}
                            {
                                env.showBody &&
                                <BodyDefault
                                    classes={classes}
                                    data={item}
                                    feedType={feedType}
                                    fullView={env.fullView}
                                    showPublisher={false}
                                    showExpandButtonIfContentEmpty={env.isDenouncement}
                                    onTextExpandedChange={this.handleTextExpanded}
                                />
                            }

                            {
                                /* Area 7 */
                                <ActionsCourse
                                    classes={classes}
                                    item={item}
                                    feedType={feedType}
                                    onCustomAction={this.props.onCustomAction}
                                    onUpdateCard={onUpdateCard}
                                />
                            }

                        </CardContent>

                        <FooterLine
                            classes={classes}
                            data={item}
                            fullView={env.fullView}
                        />


                    </RequestWrapIndicator>
                </Card>

                {this.state.dialog}
            </>
        );
    }
}

export default withSnackbar(CourseCard);
